import React from "react";
import { motion, Variants } from "framer-motion";
import "./style.scss";

interface SectionProps {
  children: React.ReactNode;
  variant?: "odd" | "even";
  className?: string;
  id?: string;
  animate?: boolean;
}

const itemVariants: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const Section: React.FC<SectionProps> = ({
  children,
  variant = "odd",
  className = "",
  id,
  animate = true,
}) => {
  const content = <div className="contentWrapper">{children}</div>;

  if (!animate) {
    return (
      <section id={id} className={`common-section ${variant} ${className}`}>
        {content}
      </section>
    );
  }

  return (
    <motion.section
      id={id}
      className={`common-section ${variant} ${className}`}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={itemVariants}
    >
      {content}
    </motion.section>
  );
};

export default Section;
